import ProgramApplication from './course/programApplication';
import ApplicationDetail from './course/applicationDetail';
import CourseUpdateApplication from './course/courseUpdateApplication';
import ApplicationUpdateView from './applicationUpdateView';
import ApplicationView from './applicationView';
import ProgramList from './program/programList';
import ProgramDetail from './program/programDetail/programDetail';
import ProgramDetailShow from "./program/programShow/programDetailShow";
import ProgramEvaluation from "./program/programEvaluation/programEvaluation";
import Exam from './exam/exam';
import ExamInfo from './exam/examInfo/examInfo'
import ExamLook from './exam/examLook/examLook'
import ChapterLook from './exam/examLook/chapterLook'
import ExamDetail from './exam/examDetail/examDetail'
import ExamAuthSelect from './exam/examAuth/examAuthSelect'
import ExamAuth from './exam/examAuth/examAuth'
import ExamTempGroupManage from './examTemplateGroup/examTempGroupManage'
import ExamChapter from './exam/examChapter/examChapter';
import ExamTemplate from './examTemplate/examTemplate'
import ExamTemplateDetail from './examTemplate/examTemplateDetail/examTemplateDetail'
import ExamTemplateChapter from './examTemplate/examTemplateChapter/examTemplateChapter'
import ExamTemplateLook from './examTemplate/examTemplateLook/examTemplateLook'
import ExamTemplateGroup from './examTemplateGroup/examTemplateGroup'
import ExamTemplateGroupDetail from './examTemplateGroup/examTemplateGroupDetail/examTemplateGroupDetail'
import ExamTemplateGroupInfo from './examTemplateGroup/examTemplateGroupInfo/examTemplateGroupInfo'
import QueryQuestionCount from './exam/examChapter/queryQuestionCount';
import ChapterPreview from './exam/examChapter/chapterPreview';
import LookPreview from './exam/examChapter/lookPreview';
import ExamRecordManager from './examRecord/examRecordManager';
import ExamGradeInfo from './examRecord/examGradeInfo/examGradeInfo';
import ExamRecordInfo from './examRecord/examRecordInfo/recordRecordInfo';
import ScheduleList from './schedule/scheduleList';
import ScheduleDetail from './schedule/scheduleDetail/scheduleDetail';
import BankQuestion from './bankQuestion/bankQuestion';
import BankQuestionDetail from './bankQuestion/bankQuestionDetail/bankQuestionDetail';
import BankQuestionImport from './bankQuestion/BankQuestionImport';

import QuestionCategorySelect from './bankQuestion/questionCategorySelect/questionCategorySelect';
import QuestionCategoryRadioSelect from './bankQuestion/questionCategorySelect/questionCategoryRadioSelect';
import BankQuestionLook from './bankQuestion/bankQuestionLook/bankQuestionLook';
import CoursewareList from "./courseware/coursewareList";
import LookCourseware from "./courseware/coursewareShow/lookCourseware";
import ProgramAuth from './program/programAuth/programAuth';
import SeriesProgramList from './seriesProgram/seriesProgramList';
import SeriesDetail from './seriesProgram/seriesDetail/seriesDetail';
import SeriesInfo from './seriesProgram/seriesDetail/seriesInfo';
import SeriesContentList from './seriesProgram/seriesContent/seriesContentList'
import SeriesContentDetail from './seriesProgram/seriesContent/seriesContentDetail'
import SeriesFileImport from './seriesProgram/seriesFileImport'

import LiveList from './live/liveList';
import LiveDetail from './live/liveDetail/liveDetail';
import AssessmentRulesList from './live/assessmentRules/assessmentRulesList';
import LiveRecordList from './live/liveRecord/liveRecordList';
import NormalDealerList from './live/normalDealer/normalDealerList';
import LiveStatisticsList from './live/liveStatistics/liveStatisticsList';
import LiveInfo from './live/liveInfo/liveInfo';
import DealerRuleImport from './live/assessmentRules/dealerRuleImport';
import HostList from './live/host/hostList'
import HostLiveRecordList from './live/host/liveRecord/hostLiveRecordList'

import HostHktList from './live/hostHkt/hostHktList'
import HktClassroom from './live/hostHkt/hktClassroom';

import ErrorQuestionInfoList from './examRecord/examErrorQuestionAnalysis/errorQuestionInfoList';
import ErrorQuestionAnalysisList from './examRecord/examErrorQuestionAnalysis/errorQuestionAnalysis/errorQuestionAnalysisList';
import ErrorQuestionPersonInfoList from './examRecord/examErrorQuestionAnalysis/errorQuestionAnalysis/errorQuestionPersonInfo/errorQuestionPersonInfoList';

import SubjectiveReview from './subjectiveReview/subjectiveReview'
import ExaminationRecord from './subjectiveReview/examinationRecord'
import ExaminationReview from './subjectiveReview/review'
import ExaminationLook from './subjectiveReview/look'

import InteractLiveResources from "./interactLiveResources/interactLiveResources";
import ResourcesLiveList from "./interactLiveResources/live/resourcesLiveList";
import ExamPersonAuthManager from "./examPersonAuth/examPersonAuthManager";
import ExamPersonAuthDetail from "./examPersonAuthDetail/examPersonAuthDetail";
import InteractLiveHktResources from "./interactLiveHktResources/interactLiveHktResources";

export {
  ProgramApplication,
  ApplicationDetail,
  CourseUpdateApplication,
  ApplicationUpdateView,
  ApplicationView,
  ProgramList,
  BankQuestionImport,
  ChapterPreview,
  LookPreview,
  ExamAuth,
  ExamLook,
  ChapterLook,
  ExamAuthSelect,
  ExamInfo,
  ProgramDetail,
  ProgramDetailShow,
  ProgramEvaluation,
  Exam,
  ExamDetail,
  ExamChapter,
  ExamTemplate,
  ExamTemplateDetail,
  ExamTemplateChapter,
  ExamTemplateLook,
  ExamTemplateGroup,
  ExamTemplateGroupDetail,
  ExamTemplateGroupInfo,
  ExamTempGroupManage,
  QueryQuestionCount,
  ExamRecordManager,
  ExamGradeInfo,
  ExamRecordInfo,
  ScheduleList,
  ScheduleDetail,
  BankQuestion,
  BankQuestionDetail,
  QuestionCategorySelect,
  BankQuestionLook,
  QuestionCategoryRadioSelect,
  ProgramAuth,
  SeriesProgramList,
  SeriesDetail,
  SeriesInfo,
  SeriesContentList,
  SeriesContentDetail,
  LiveList,
  LiveDetail,
  AssessmentRulesList,
  LiveRecordList,
  NormalDealerList,
  LiveStatisticsList,
  LiveInfo,
  DealerRuleImport,
  HostList,
  CoursewareList,
  LookCourseware,
  HostLiveRecordList,
  SeriesFileImport,
  ErrorQuestionInfoList,
  ErrorQuestionAnalysisList,
  ErrorQuestionPersonInfoList,
  SubjectiveReview,
  ExaminationRecord,
  ExaminationReview,
  ExaminationLook,
  InteractLiveResources,
  ResourcesLiveList,
  ExamPersonAuthManager,
  ExamPersonAuthDetail,
  HostHktList,
  InteractLiveHktResources,
  HktClassroom
}


